import { Injectable } from '@angular/core';

import { translate } from '../../features/translate/translate';
import { TranslationPipe } from '../../features/translate/translation.pipe';
import { EStatus } from '../../shared/enums/status.enum';
import { EPriority } from './priorities';

@Injectable({
  providedIn: 'root',
})
export class PointsHelperService {
  constructor(private translationPipe: TranslationPipe) {}

  humanizePriorityName(priority: EPriority): string {
    switch (priority) {
      case EPriority.HIGH:
        return this.translationPipe.transform('high');
      case EPriority.MEDIUM:
        return this.translationPipe.transform('medium');
      case EPriority.LOW:
        return this.translationPipe.transform('low');
      default:
        return '';
    }
  }

  humanizeStatusName(status: EStatus): string {
    switch (status) {
      case EStatus.OPEN:
        return this.translationPipe.transform('open');
      case EStatus.IN_PROGRESS:
        return this.translationPipe.transform('in_progress');
      case EStatus.ONHOLD:
        return this.translationPipe.transform('on_hold');
      case EStatus.TO_REVIEW:
        return this.translationPipe.transform('to_review');
      case EStatus.CANCELED:
        return this.translationPipe.transform('canceled');
      case EStatus.CLOSED:
        return this.translationPipe.transform('completed');
      default:
        return '';
    }
  }

  priorityToColor(priority: EPriority): string {
    switch (priority) {
      case EPriority.HIGH:
        return 'red';
      case EPriority.MEDIUM:
        return 'yellow';
      case EPriority.LOW:
        return 'blue';
      default:
        return 'gray';
    }
  }

  statusPriorityToColor(statusPriority: string): string {
    switch (statusPriority) {
      case EStatus.OPEN:
        return 'gray';
      case EStatus.IN_PROGRESS:
        return 'purple';
      case EStatus.ONHOLD:
        return 'orange';
      case EStatus.TO_REVIEW:
        return 'olive';
      case EStatus.CANCELED:
        return 'maroon';
      case EStatus.CLOSED:
        return 'green';
      case EPriority.HIGH:
        return 'red';
      case EPriority.MEDIUM:
        return 'yellow';
      case EPriority.LOW:
        return 'blue';
      default:
        return 'OTHER';
    }
  }

  humanizeActivityChange(activityChange: string): string {
    switch (activityChange) {
      case EStatus.OPEN:
        return translate('open');
      case EStatus.IN_PROGRESS:
        return translate('in_progress');
      case EStatus.ONHOLD:
        return translate('on_hold');
      case EStatus.TO_REVIEW:
        return translate('to_review');
      case EStatus.CANCELED:
        return translate('canceled');
      case EStatus.CLOSED:
        return translate('completed');
      case EPriority.HIGH:
        return translate('high');
      case EPriority.MEDIUM:
        return translate('medium');
      case EPriority.LOW:
        return translate('low');
      default:
        return activityChange;
    }
  }
}
